export default __webpack_public_path__ + "static/media/rectangle-blue.f73ed374.svg";